import { LowerCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxIconName, OnyxOptional } from '@onyx/angular';
import {
  OnyxDatePipe,
  OnyxIconComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import { DictionaryCode } from '../../../enums/dictionary-code';
import { DriverUnavailabilityReason } from '../../../enums/driver-unavailability-reason';
import type { Unavailability } from '../../../interfaces/common/unavailability';

@Component({
  selector: 'app-unavailability-icon',
  imports: [
    OnyxIconComponent,
    OnyxTooltipDirective,
    TranslatePipe,
    OnyxDatePipe,
    LowerCasePipe,
  ],
  templateUrl: './unavailability-icon.component.html',
  styleUrl: './unavailability-icon.component.scss',
})
export class UnavailabilityIconComponent {
  public readonly unavailability = input<OnyxOptional<Unavailability>>(null);

  protected readonly DictionaryCode = DictionaryCode;

  protected icon = computed<OnyxIconName | null>(() => {
    const unavailability = this.unavailability();
    if (!unavailability) return null;

    const reasons = {
      [DriverUnavailabilityReason.SICK_LEAVE]: 'sick-leave-outlined',
      [DriverUnavailabilityReason.VACATION]: 'vacation-outlined',
    } as const;
    return reasons[unavailability.reason];
  });
}
